import { render, staticRenderFns } from "./ProfileInvitations.vue?vue&type=template&id=1f1cbd06&"
import script from "./ProfileInvitations.vue?vue&type=script&lang=js&"
export * from "./ProfileInvitations.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInvitations.vue?vue&type=style&index=0&id=1f1cbd06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports